import { ShareLinkQuery, ShareLinkQueryImp } from './share-link-query';
export function shareLinkModule(bind) {
    bind(ShareLinkQuery).to(ShareLinkQueryImp);
}
